module.exports = __webpack_public_path__ + "img/turtle.0ba2fa65.png";